import { validEmail } from './regex';

interface Values {
  email: string;
}

export function simpleValidateEmail(inputEmail: string): boolean {
  if (!inputEmail) {
    return false;
  }

  return !!String(inputEmail)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
}

export default function validateEmail(values: Values, t: (key: string) => string) {
  const errors: Record<string, string> = {};

  if (!values.email) {
    errors.email = t('components.email-required');
  } else if (!validEmail.test(values.email)) {
    errors.email = t('components.enter-valid-email');
  }

  return errors;
}
